import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

// Styles
import './styles.scss';

// Props and Context
const propTypes = {
  alwaysActive: PropTypes.bool,
  children: PropTypes.node.isRequired,
  settings: PropTypes.object,
  sliderBreakpoint: PropTypes.number,
};

const defaultProps = {
  alwaysActive: false,
  settings: {},
  sliderBreakpoint: 0,
};

const contextTypes = {
  t: PropTypes.func,
};

class CardGrid extends Component {
  constructor(props) {
    super(props);
    this.state = { isSlider: false };
    this.determineContainerElement = this.determineContainerElement.bind(this);
  }

  componentDidMount() {
    const { alwaysActive, sliderBreakpoint } = this.props;
    if (alwaysActive || sliderBreakpoint > 0) {
      window.addEventListener('resize', this.determineContainerElement);
    }
    this.determineContainerElement();
  }

  componentWillUnmount() {
    const { alwaysActive, sliderBreakpoint } = this.props;
    if (alwaysActive || sliderBreakpoint > 0) {
      window.removeEventListener('resize', this.determineContainerElement);
    }
  }

  determineContainerElement() {
    const { alwaysActive, sliderBreakpoint } = this.props;
    this.setState({
      isSlider: (alwaysActive || window.innerWidth < sliderBreakpoint),
    });
  }
  render() {
    const { isSlider } = this.state;
    const { settings, children } = this.props;
    if (!isSlider) {
      return (
        <div className="grid__items">
          {children}
        </div>
      );
    }
    return (
      <Slider {...settings}>
        {children}
      </Slider>
    );
  }
}

CardGrid.contextTypes = contextTypes;
CardGrid.propTypes = propTypes;
CardGrid.defaultProps = defaultProps;

export default CardGrid;



// WEBPACK FOOTER //
// ./src/app/components/cards/cardGrid/CardGrid.js